import React, { useEffect, useState } from 'react';
import './Leaderboard.css';
import './universal.css';

function Leaderboard() {
  const [leaderboard, setLeaderboard] = useState([]);

  useEffect(() => {
    async function fetchLeaderboard() {
      try {
        //const response = await fetch('http://127.0.0.1:5001/ki2ne-games/us-central1/getleaderboard2');
        const response = await fetch('https://us-central1-ki2ne-games.cloudfunctions.net/getleaderboard2');
        const data = await response.json();
        // Sort the leaderboard by score in descending order
        const sortedLeaderboard = data.leaderboard.sort((a, b) => a.seconds - b.seconds);
        setLeaderboard(sortedLeaderboard);
      } catch (error) {
        console.error('Error fetching leaderboard:', error);
      }
    }

    fetchLeaderboard();
  }, []);

  return (
    <div className="leaderboard-container">
      <header className="leaderboard-header smooch-sans-header">
        Leaderboard
      </header>
      <ul className="leaderboard">
        {leaderboard.map((entry, index) => (
          <li key={index} className="leaderboard-item smooch-sans-leaderboard-item">
            <div className="leaderboard-name">{index < 1 ? "🥇" : (index < 2 ? "🥈" : (index < 3 ? "🥉" : ""))}{entry.name}</div>
            <div className="leaderboard-score">{Math.floor(entry.seconds / 60)}:{entry.seconds % 60 < 10 ? `0${entry.seconds % 60}` : entry.seconds % 60}</div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Leaderboard;